import React, { PropTypes } from 'react'
import Link from 'react-router/lib/Link'
import Table from 'react-bootstrap/lib/Table'
import Bullet from 'react-icons/lib/md/adjust'

const SearchResultItem  = ({ item, linkBase }) => (
  <Link to={`${linkBase}/${item.get('id')}`} className="list-group-item">
    <Table hover condensed>
      <tbody>
        <tr>
          <td width="10"><span className="btn-icon btn-inline"><Bullet /></span></td>
          <td width="100"><small className="text-primary">{item.get('code')}</small></td>
          <td>{item.get('name')}</td>
        </tr>
      </tbody>
    </Table>
  </Link>
)

SearchResultItem.propTypes = {
  item: PropTypes.object,
}

export default SearchResultItem



// WEBPACK FOOTER //
// ./src/containers/Students/search-result-item.js